import { createApp } from 'vue'
import App from './App.vue'

//TailwindCSS
import "./index.css"

//Router
import router from './router'

//Store
import store from './store'

//Moment
import moment from 'moment'
import "moment/locale/fr"
import Popper from 'vue3-popper'
import "leaflet/dist/leaflet.css";
import { WaveSurferPlayer } from '@meersagor/wavesurfer-vue'
moment.locale("fr")



const app = createApp(App)



app.use(store)
app.use(router)
app.component("ToolTip",Popper)
app.component("AudioLector",WaveSurferPlayer)
app.mount('#app')
